
import {Component, Prop, Vue} from "vue-property-decorator";
import DataFieldCache from "../../../models/data.field.cache";
import DataFieldBar from "@/components/study/datafields/base/DataFieldBar.vue";
import dataFieldTypes from "@/dataFieldTypes";
import YesNoDialog from "@/components/common/YesNoDialog.vue";
import {dataFieldsEditModule} from "@/store";
import {stringify} from "@/auxillary/datafield.stringify";

@Component({
  name: 'ListEntryField',
  components: {
    ...dataFieldTypes,
    DataFieldBar,
    YesNoDialog,
  },
})
export default class ListEntryField extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  errorMessage: string = "";
  showDeleteDialog = false;

  get isVisible() {
    return this.dataField?.isVisible ?? false;
  }

  get childNames() {
    return this.dataField.definition.names ?? [{
      template: "{0}",
      field: ["name"]
    }];
  }

  get childName() {

    let name = "";

    for (const childName of this.childNames) {
      // find field
      let field: any = undefined;
      for (const fieldIdentifier of childName.field) {
        if (field === undefined) {
          field = this.childFields.find(d => d.identifier == fieldIdentifier)
          if (field === undefined)
            break;
          continue;
        }

        field = field.childFields.find((d: any) => d.identifier == fieldIdentifier)
        if (field === undefined)
          break;
      }
      if (field?.values == null)
        continue;

      const fieldName = stringify(field);
      if (fieldName)
        name += childName.template.replace("{0}", fieldName);
    }

    if (name == "")
      return "(keine Eintragung)";

    return name;
  }

  get isEditable() {
    return this.dataField.isEditable;
  }

  get childHasMessage() {

    const allChildFields = this.childFields.traverse(d => d.childFields) ?? []
    for (let childField of allChildFields) {
      if (dataFieldsEditModule.validationMessages
          .some(vm => vm.dataFieldId == childField.id))
        return true;
    }
    return false;
  }

  get displayName() {
    return this.dataField?.displayName;
  }

  get stringifyValue() {
    return stringify(this.dataField)
  }

  get childFields() {
    return this.dataField?.childFields ?? [];
  }

  deleteMe() {
    dataFieldsEditModule.removeField(this.dataField);
    this.showDeleteDialog = false
  }

}
